module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/general-settings/general-settings.component.scss
// module id = ./src/app/home/pages/Dashboard/AdminDashboardPages/System settings/general-settings/general-settings.component.scss
// module chunks = main